import Vue from 'vue';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

moment.tz.setDefault('Europe/Riga');
moment.defaultFormat = 'DD.MM.YYYY HH:mm:ss';

Vue.use(VueMoment, {
  moment,
});
